import * as React from "react"
import type { SVGProps } from "react"
const SvgChatGpt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M9.67 9.28v-1.9q0-.24.2-.36l3.79-2.2a3.5 3.5 0 0 1 1.76-.44 3.8 3.8 0 0 1 3.86 4.3l-3.92-2.32a.7.7 0 0 0-.71 0zm8.84 7.4v-4.54a.7.7 0 0 0-.36-.62L13.18 8.6l1.62-.94a.4.4 0 0 1 .4 0l3.8 2.2c1.09.64 1.82 2 1.82 3.32 0 1.52-.9 2.92-2.3 3.5m-10-4-1.63-.96q-.2-.12-.2-.36v-4.4A3.7 3.7 0 0 1 10.5 3.2q1.27.01 2.26.78l-3.9 2.28a.7.7 0 0 0-.36.62zM12 14.72 9.67 13.4v-2.8L12 9.28l2.33 1.32v2.8zm1.5 6.08q-1.27-.02-2.26-.78l3.9-2.28a.7.7 0 0 0 .36-.62v-5.8l1.64.96q.2.12.2.36v4.4a3.7 3.7 0 0 1-3.84 3.76m-4.7-4.46L5 14.14a4 4 0 0 1-1.82-3.32c0-1.54.91-2.92 2.32-3.5v4.56q0 .42.36.62l4.95 2.9-1.62.94a.4.4 0 0 1-.4 0m-.22 3.28a3.8 3.8 0 0 1-3.88-3.8q0-.24.04-.48l3.9 2.28q.36.21.71 0l4.98-2.9v1.9q0 .24-.2.36l-3.79 2.2a3.5 3.5 0 0 1-1.76.44M13.5 22c2.4 0 4.4-1.72 4.85-4a5 5 0 0 0 1.98-8.56q.16-.63.16-1.26a4.97 4.97 0 0 0-6.52-4.74A4.95 4.95 0 0 0 5.65 6a5 5 0 0 0-1.99 8.56q-.15.63-.15 1.26a4.97 4.97 0 0 0 6.52 4.74A5 5 0 0 0 13.5 22" />
  </svg>
)
export default SvgChatGpt
